import { render } from "./CustomizeEvent.vue?vue&type=template&id=4afff173"
import script from "./CustomizeEvent.vue?vue&type=script&lang=js"
export * from "./CustomizeEvent.vue?vue&type=script&lang=js"

import "./CustomizeEvent.vue?vue&type=style&index=0&id=4afff173&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__